import React from 'react';
import { ExternalLink } from 'lucide-react';

const SHOP_URL = 'https://tecnicheperfette.bigcartel.com/';

const products = [
  {
    id: 'maglietta-nera',
    name: 'Maglietta Nera',
    image:
      'https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/gpa43xih_maglietta%2Bnera%2Bscritta%2Bbianca.webp',
  },
  {
    id: 'felpa',
    name: 'Felpa Merch',
    image:
      'https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/e5mxgxrb_felpa%2Bmerch.webp',
  },
  {
    id: 'felpa-2',
    name: 'Felpa Merch 2',
    image:
      'https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/k2nvw3zg_felpa%202%20merch.avif',
  },
];

const BigCartelShopPage = () => {
  return (
    <div
      className="py-8 sm:py-12 px-4"
      style={{ backgroundColor: 'var(--tp-black)', minHeight: '90vh' }}
      data-testid="shop-page"
    >
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <h1
          className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-2 text-white"
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}
        >
          SHOP
        </h1>
        <div
          className="w-20 h-1 mx-auto mb-3"
          style={{ backgroundColor: 'var(--tp-red)' }}
        />
        <p
          className="text-center text-gray-300 text-sm sm:text-base mb-8 max-w-2xl mx-auto"
          style={{ fontFamily: 'Oswald, sans-serif' }}
        >
          Merchandising ufficiale Tecniche Perfette. Clicca su un prodotto per acquistarlo sul nostro store.
        </p>

        {/* Products grid */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10"
          data-testid="shop-products-grid"
        >
          {products.map((p) => (
            <a
              key={p.id}
              href={SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`shop-product-${p.id}`}
              className="group relative block rounded-lg overflow-hidden border border-gray-800 hover:border-red-600 transition-all duration-300 bg-[#151516]"
            >
              <div className="aspect-square overflow-hidden bg-black">
                <img
                  src={p.image}
                  alt={p.name}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
                <span
                  className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[var(--tp-red)] text-white font-bold text-xs"
                  style={{ fontFamily: 'Oswald, sans-serif' }}
                >
                  <ExternalLink size={14} />
                  ACQUISTA
                </span>
              </div>
              <div className="p-4 border-t border-gray-800">
                <p
                  className="text-white font-bold text-sm sm:text-base text-center tracking-wide"
                  style={{ fontFamily: 'Oswald, sans-serif' }}
                >
                  {p.name}
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* CTA button Bigcartel */}
        <div className="flex justify-center">
          <a
            href={SHOP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="shop-open-new-tab"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[var(--tp-red)] hover:bg-[var(--tp-red-light)] text-white font-bold text-sm transition-colors shadow-lg"
            style={{ fontFamily: 'Oswald, sans-serif' }}
          >
            <ExternalLink size={18} />
            VISITA LO SHOP COMPLETO
          </a>
        </div>
      </div>
    </div>
  );
};

export default BigCartelShopPage;
